import { useHistory, useParams } from 'react-router-dom'
import useEntity from '../../hooks/useEntity'
import Loading from '../../components/Loading'
import * as React from 'react'
import LegalPersonForm, { LegalPersonMutationDto } from '../../components/Form/Party/LegalPersonForm'
import useAxios from '../../hooks/useAxios'
import { sortTiers } from '../../components/Form/Tier/TierList'
import useUsers from '../../hooks/useUsers'
import useAttributes, { AttributeContextType, AttributeViewType, EntityAttributeType } from '../../hooks/useAttributes'
import { applyDocumentRootPath } from '../../components/Form/Party/PartyForm'
import { useTranslation } from 'react-i18next'

export default function EditLegalPerson() {
    const axios = useAxios()
    const history = useHistory()
    const { id } = useParams<{ fileId?: string; id?: string }>()
    const { t: translate } = useTranslation()
    const users = useUsers()

    const attributes = useAttributes(AttributeViewType.Input, [AttributeContextType.LegalPerson], undefined, EntityAttributeType.Party)

    const [entity] = useEntity<LegalPersonMutationDto>(
        id => ({ url: `/party/${id}` }),
        id,
        response => ({
            ...response.data,
            tiers: sortTiers(users, response.data.tiers),
        }),
    )

    if (!entity.loaded) {
        return <Loading />
    }

    return (
        <LegalPersonForm
            formikProps={{
                initialValues: {
                    addressCountry: 'NL',
                    poBoxAddressCountry: 'NL',
                    ...entity.data,
                },
            }}
            onSubmit={async (party: LegalPersonMutationDto) => {
                await applyDocumentRootPath(axios, translate, party)
                return await axios.put<string>(`/party/legal/${id}`, party)
            }}
            goBack={() => {
                history.goBack()
                setTimeout(() => {
                    history.replace({ ...history.location, state: { reload: true } })
                }, 10)
            }}
            attributes={attributes}
        />
    )
}
